module.exports = __webpack_public_path__ + "img/arrow-filter.91e6caa3.svg";